import { useEffect, useState } from "react";
import styles from "./DailyRewardModalContent.module.css";

import chest from "/DailyReward/chest.webp";
import { useModalStore } from "../../Store/ModalStore";
import RewardSquare from "./RewardSquare";
import { MainButton } from "../../Components/MainButton/MainButton";
import {
  checkSubscription,
  getDailyRewards,
  getInvoice,
  postPartnerTasksGetReward,
} from "../../Services/Requests";
import { useNotificationStore } from "../../Store/NotificationStore";
import useUserStore from "../../Store/UserStore";
import icon from "../../../../public/DailyReward/starIconReward.svg";

export interface Reward {
  type: string;
  amount: number;
  tripled_amount: number;
}

export interface TaskDetails {
  current_day: boolean;
  promote_link: string;
  partner_id: number;
  tripled_price_XTR: number;
}

export interface Task {
  id: number;
  slug: string;
  name: string;
  type: string;
  target_progress: number;
  icon: string;
  details: TaskDetails;
  rewards: Reward[];
  status: string;
  partner: string | null;
  user_progress: number;
}

export interface DailyRewardData {
  task_group_id: number;
  slug: string;
  name: string;
  description: string;
  icon_url: string;
  banner_url: string;
  tasks: Task[]; // Массив всех задач (по дням)
  completed_tasks: number;
  total_tasks: number;
  type: string; // Например, "individual"
  rewards: Reward[]; // Финальные награды за выполнение всех задач
}

interface DailyRewardModalContentProps {
  onClose: () => void;
}

const DailyRewardModalContent = ({ onClose }: DailyRewardModalContentProps) => {
  const tg = window.Telegram.WebApp;

  const [dailyRewardData, setDailyRewardData] =
    useState<DailyRewardData | null>(null);
  const setClosing = useModalStore((state) => state.setClosing);
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const [pressed, setPressed] = useState(false);

  const balanceDC = useUserStore((state) => state.balanceDC);
  const setBalanceDC = useUserStore((state) => state.setBalanceDC);

  useEffect(() => {
    const fetchDailyTasks = async () => {
      try {
        const response = await getDailyRewards();
        if (response) {
          setDailyRewardData(response);
          console.log(response);
        }
      } catch (error) {
        console.error("Ошибка при получении ежедневных наград:", error);
      }
    };

    fetchDailyTasks();
  }, []);

  if (!dailyRewardData) {
    return;
  }

  const thisDayPrize = dailyRewardData.tasks.filter(
    (item) => item.details.current_day
  );

  const combinedArray = thisDayPrize[0].rewards.map((reward) => ({
    amount: reward.amount,
    type: reward.type,
  }));

  const trippledArray = thisDayPrize[0].rewards.map((reward) => ({
    type: reward.type,
    amount: reward.tripled_amount,
  }));
  console.log(trippledArray);

  const handleGetReward = async (type: string) => {
    try {
      if (type === "trippled") {
        const dcReward = trippledArray.find((item) => item.type === "DC");
        console.log(dcReward);
        console.log(dcReward?.amount);
        if (dcReward) {
          setBalanceDC(balanceDC + dcReward.amount);
        }
        setClosing(true);
        onClose();
        setTimeout(() => {
          setNotification({
            type: "Success",
            message: "Поздравляем, ты получил :",
            rewards: trippledArray,
          });
        }, 300);
        return;
      } else {
        const dcReward = combinedArray.find((item) => item.type === "DC");
        if (dcReward) {
          setBalanceDC(balanceDC + dcReward.amount);
        }
        setClosing(true);
        onClose();
        setTimeout(() => {
          setNotification({
            type: "Success",
            message: "Поздравляем, ты получил :",
            rewards: combinedArray,
          });
        }, 300);
      }
    } catch (error) {
      setClosing(true);
      onClose();
      setTimeout(() => {
        setNotification({
          type: "Error",
          message: "Ошибка при получении награды. Попробуй позже!",
        });
      }, 300);
    }
  };
  const handleNavigate = () => {
    tg.openTelegramLink(thisDayPrize[0].details.promote_link);
    setPressed(true);
  };

  const handleCheckSubscription = async ({
    isTrippled = false,
  }: {
    isTrippled?: boolean;
  }) => {
    if (isTrippled) {
      try {
        const invoice = await getInvoice({
          title: "reward trippled",
          description: "reward trippled",
          amount: thisDayPrize[0].details.tripled_price_XTR,
          id: thisDayPrize[0].id,
          item_type: "daily-bonus",
        });

        tg.openInvoice(invoice.invoice_link, async (status: string) => {
          console.log("Статус оплаты", status);
          if (status === "paid") {
            try {
              const response = await checkSubscription(
                thisDayPrize[0].id,
                thisDayPrize[0].details.partner_id,
                true
              );
              if (response.status === "CLAIMED") {
                handleGetReward("trippled");
              } else {
                setNotification({
                  type: "Error",
                  message: "Ошибка проверки подписки. Попробуй позже!",
                });
              }
            } catch {
              setNotification({
                type: "Error",
                message: "Ошибка при утроении награды. Попробуй позже!",
              });
            }
          } else {
            console.log("Ошибка оплаты", status);
            setNotification({
              type: "Error",
              message: "Оплата не была завершена",
            });
          }
        });
      } catch {
        setNotification({
          type: "Error",
          message: "Ошибка при утроении награды. Попробуй позже!",
        });
        setPressed(false);
      }
    } else {
      try {
        const response = await checkSubscription(
          thisDayPrize[0].id,
          thisDayPrize[0].details.partner_id,
          false
        );

        if (response.status === "CLAIMED") {
          handleGetReward("default");
        } else {
          setNotification({
            type: "Error",
            message: "Ошибка проверки подписки. Попробуй позже!",
          });
          setPressed(false);
        }
      } catch (error: any) {
        if (error.response?.status === 400) {
          setNotification({
            type: "Error",
            message: "Вы не подписались на канал.",
          });
          setPressed(false);
        }
      }
    }
  };

  const isClaimed = dailyRewardData.tasks.filter(
    (item) => item.status === "CLAIMED" && item.details.current_day
  );

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <div className={styles.circle}></div>
        <img src={chest} className={styles.chestImg} alt="Сундук" />
      </div>

      <div className={styles.text}>
        <div className={styles.header}>Новый день – новая награда!</div>
        <div className={styles.subText}>
          Заходи в игру каждый день, чтобы получать лучшие награды!
        </div>
      </div>
      <div className={styles.dailyRewards}>
        {dailyRewardData.tasks.map((rew, index) => (
          <RewardSquare rew={rew} index={index} data={dailyRewardData} />
        ))}
      </div>

      {isClaimed.length > 0 ? (
        <MainButton
          text="Награда уже собрана"
          isActive={false}
          color="rgba(255, 255, 255, 0.14)"
          textColor="#ffffff"
        />
      ) : !pressed ? (
        <>
          <MainButton
            text="Подписаться"
            onClick={handleNavigate}
            color="#83B63A"
            textColor="#ffffff"
          />
          <button
            className={styles.trippledButton}
            onClick={() => handleCheckSubscription({ isTrippled: true })}
          >
            <div>Получить х3 награду за</div>
            <div className={styles.trippledAmountBlock}>
              <div>{thisDayPrize[0].details.tripled_price_XTR}</div>
              <div>
                <img className={styles.iconStar} src={icon} alt="icon" />
              </div>
            </div>
          </button>
        </>
      ) : (
        <>
          <MainButton
            text="Проверить подписку"
            onClick={() => handleCheckSubscription({ isTrippled: false })}
            color="#83B63A"
            textColor="#ffffff"
          />
          <button
            className={styles.trippledButton}
            onClick={() => handleCheckSubscription({ isTrippled: true })}
          >
            <div>Получить х3 награду за</div>
            <div className={styles.trippledAmountBlock}>
              <div>{thisDayPrize[0].details.tripled_price_XTR}</div>
              <div>
                <img className={styles.iconStar} src={icon} alt="icon" />
              </div>
            </div>
          </button>
        </>
      )}
    </div>
  );
};

export default DailyRewardModalContent;
